import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
// components
import Page from '../components/Page';
import Iconify from '../components/Iconify';
// sections
import {
  AppTasks,
  AppNewsUpdate,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppWidgetSummary,
  AppCurrentSubject,
  AppConversionRates,
} from '../sections/@dashboard/app';

import EmpProductivity from './EmpProductivity';
import HeadCountDashboard from './HeadCountDashboard';
import useDashboardInd from 'src/api/useDashboardInd';
import { useNavigate } from 'react-router-dom';
// ----------------------------------------------------------------------

// Object.defineProperty(String.prototype, 'capitalize', {
//   value: function () {
//     return this.charAt(0).toUpperCase() + this.slice(1);
//   },
//   enumerable: false
// });

const capitalize = (str) =>
  str && typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : str;

const cc = ['primary', 'secondary', 'info', 'success', 'warning']

export default function DashBoardAppind({ clientId, userType }) {
  const navigate = useNavigate();
  //const theme = useTheme();
  // console.log(clientId)
  const {
    alldata,
    graph,
    getIcon
  } = useDashboardInd()

  console.log('alldata:', JSON.stringify(alldata));
  
  const getEvents = (type) => {
    const filterData = {
      Type:type
    };
    console.log('filterData before navigate:', filterData);
    navigate('/audits', { state: { filterData } });
  };

  return (
    <Page title="Dashboard">
      <Container maxWidth="xxl" style={{padding:0}}>
        <Typography variant="h4" sx={{ mb: 5 }}>
         Dashboard
        </Typography>

        <Grid container spacing={3}>

          <Grid item xs={12} md={12} lg={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} lg={4}>
                {(Number(clientId) === 797  && (Number(userType) === 30 || Number(userType) === 2 || Number(userType) === 7))  && (<HeadCountDashboard/>)}  
                {(Number(clientId) === 691)  && (<HeadCountDashboard/>)}    
  
                {Number(userType) !== 30 && (
                  <AppWebsiteVisits
                  title="Audits Track"
                  xtittle="Hours Of The Day"
                  ytittle="Audits Count"
                  subheader={`Total Audits ${graph.total}`}
                  chartLabels={Object.keys(graph.data)}
                  chartData={[
                    {
                      name: 'Audits ',
                      type: 'line',
                      fill: 'solid',
                      data: Object.values(graph.data),
                    },
                  ]}
                  sx={{  px: 1 }}
                />
                )}                
              </Grid>
              {Number(userType) !== 30 && (
                <Grid item xs={12} md={8} lg={8}>
                  <Grid container spacing={2}>
                    {alldata.data.map((row, key) => (
                      <Grid item xs={6} sm={6} md={3} key={key}>
                        {/* <AppWidgetSummary title={row.Name.capitalize()} total={row.cunt} color={cc[key] || 'primary'} icon={getIcon(row.Name)} /> */}
                        <AppWidgetSummary 
                          type= {row.Name}
                          title={capitalize(row.Name)} 
                          total={row.cunt} 
                          color={cc[key] || 'primary'}
                          icon={getIcon(row.Name)} 
                          getEvents={getEvents} 
                       /> 
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}              
            </Grid>
          </Grid>          
          {/* <Grid item md={12}>
            <EmpProductivity />
          </Grid> */}

          {/* <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Weekly Sales" total={714000} icon={'ant-design:android-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="New Users" total={1352831} color="info" icon={'ant-design:apple-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Item Orders" total={1723315} color="warning" icon={'ant-design:windows-filled'} />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <AppWidgetSummary title="Bug Reports" total={234} color="error" icon={'ant-design:bug-filled'} />
          </Grid> */}



          {/* <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits
              title="Current Visits"
              chartData={[
                { label: 'America', value: 4344 },
                { label: 'Asia', value: 5435 },
                { label: 'Europe', value: 1443 },
                { label: 'Africa', value: 4443 },
              ]}
              chartColors={[
                theme.palette.primary.main,
                theme.palette.chart.blue[0],
                theme.palette.chart.violet[0],
                theme.palette.chart.yellow[0],
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates
              title="Conversion Rates"
              subheader="(+43%) than last year"
              chartData={[
                { label: 'Italy', value: 400 },
                { label: 'Japan', value: 430 },
                { label: 'China', value: 448 },
                { label: 'Canada', value: 470 },
                { label: 'France', value: 540 },
                { label: 'Germany', value: 580 },
                { label: 'South Korea', value: 690 },
                { label: 'Netherlands', value: 1100 },
                { label: 'United States', value: 1200 },
                { label: 'United Kingdom', value: 1380 },
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject
              title="Current Subject"
              chartLabels={['English', 'History', 'Physics', 'Geography', 'Chinese', 'Math']}
              chartData={[
                { name: 'Series 1', data: [80, 50, 30, 40, 100, 20] },
                { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
                { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
              ]}
              chartColors={[...Array(6)].map(() => theme.palette.text.secondary)}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppNewsUpdate
              title="Last Events"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: faker.name.jobTitle(),
                description: faker.name.jobTitle(),
                image: `/static/mock-images/covers/cover_${index + 1}.jpg`,
                postedAt: faker.date.recent(),
              }))}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite
              title="Traffic by Site"
              list={[
                {
                  name: 'FaceBook',
                  value: 323234,
                  icon: <Iconify icon={'eva:facebook-fill'} color="#1877F2" width={32} height={32} />,
                },
                {
                  name: 'Google',
                  value: 341212,
                  icon: <Iconify icon={'eva:google-fill'} color="#DF3E30" width={32} height={32} />,
                },
                {
                  name: 'Linkedin',
                  value: 411213,
                  icon: <Iconify icon={'eva:linkedin-fill'} color="#006097" width={32} height={32} />,
                },
                {
                  name: 'Twitter',
                  value: 443232,
                  icon: <Iconify icon={'eva:twitter-fill'} color="#1C9CEA" width={32} height={32} />,
                },
              ]}
            />
          </Grid> */}

          {/* <Grid item xs={12} md={6} lg={8}>
            <AppTasks
              title="Tasks"
              list={[
                { id: '1', label: 'Create FireStone Logo' },
                { id: '2', label: 'Add SCSS and JS files if required' },
                { id: '3', label: 'Stakeholder Meeting' },
                { id: '4', label: 'Scoping & Estimations' },
                { id: '5', label: 'Sprint Showcase' },
              ]}
            />
          </Grid> */}
        </Grid>
      </Container>
    </Page>
  );
}
